<template>
  <div class="footer-contact">
    <div class="title">
      {{ t("title") }}
    </div>
    <div class="details-container">
      <div class="number-container">
        <div class="m-cgg-icon--phone-fill" />
        <div class="number">{{ t("contact.phone") }}</div>
      </div>
      <div class="schedule">
        {{ t("contact.schedule") }}
      </div>
    </div>
    <div class="cost">
      {{ t("contact.cost") }}
    </div>
  </div>
</template>

<script lang="ts" setup>
const { t } = useI18n();
</script>

<style lang="scss" scoped>
.footer-contact {
  display: grid;
  align-items: center;
  gap: 8px;
  border-radius: 16px;
  border: 1px solid $disabled-grey;
  background: $white;
  padding: 12px 16px;

  @media screen and (min-width: $break-md-min) {
    max-width: none;
    grid-template-columns: repeat(3, auto);
    gap: 12px;
    margin: 0;
    border-radius: 32px;
  }

  .title {
    font-size: 14px;
    font-weight: 700;
  }

  .details-container {
    display: flex;
    align-items: center;
    gap: 8px;

    .number-container {
      display: flex;
      align-items: center;
      gap: 8px;

      .m-cgg-icon--phone-fill {
        color: $main-blue;
        font-size: 16px;
      }

      .number {
        font-size: 13px;
        font-weight: 700;
        text-decoration: underline;
      }
    }

    .schedule {
      padding-left: 8px;
      border-left: 1px solid $light-grey;
      font-size: 13px;
    }
  }

  .cost {
    color: $dark-grey;
    font-size: 12px;
  }
}
</style>

<i18n lang="json">
{
  "pt": {
    "title": "Precisas de ajuda?"
  }
}
</i18n>
